/**
 * O que o app faz, em uma linha cada — o desfile da tela de carga.
 *
 * ── Por que isto existe ───────────────────────────────────────────────────
 *
 * A espera normal dura dois segundos e não precisava de nada. Quem precisa é
 * a OUTRA: o Render free hiberna com ~15 min de silêncio, e acordar leva
 * dezenas de segundos. Nessa, uma tela com um anel girando e uma frase parada
 * parece travada — e quem espera trinta segundos sem sinal de vida fecha a
 * aba.
 *
 * Então o desfile não é enfeite: é o que transforma uma espera muda numa
 * espera com assunto. E de quebra apresenta o produto para quem chegou hoje.
 *
 * ── Por que não são as `dicas` ────────────────────────────────────────────
 *
 * `utils/dicas.ts` é outra coisa: cada dica ensina uma ação e aponta para
 * onde clicar. Aqui não há onde clicar — a tela some sozinha. Frases de dica
 * numa tela sem alvo seriam promessas sem endereço, que é exatamente o que o
 * comentário de lá diz para não fazer.
 *
 * Estas são NOMES de serviço, curtos, para ler de relance.
 *
 * ── Por que módulo puro ───────────────────────────────────────────────────
 *
 * Sem DOM e sem timer: quem gira é a tela. Assim a regra de rotação se testa
 * sem montar componente nenhum.
 */
export const SERVICOS: string[] = [
  'Projeção do seu saldo, mês a mês',
  'Lançamento por WhatsApp',
  'Comprovante virando transação',
  'Limite por cartão, com aviso antes de estourar',
  'Metas e tetos por categoria',
  'Dívidas com prazo e evolução',
  'Lembretes das contas do mês',
  'Relatório mensal no seu email',
  'Investimentos com projeção de rendimento',
  'Resposta para "quanto ainda posso gastar?"',
  /*
   * A décima primeira, e a única que fala de OUTRA pessoa.
   *
   * O nome do serviço é o que ele faz, não o nome da tela: "Nossa conta" só
   * significa alguma coisa para quem já entrou nela. Quem está esperando o app
   * abrir pela primeira vez precisa da frase que descreve a promessa.
   */
  'Gastos da casa somados, sem misturar o pessoal',
];

/** Quanto tempo cada frase fica. */
export const TEMPO_DE_CADA_MS = 2600;

/**
 * A frase da vez, a partir de quantas já passaram.
 *
 * ── Por que dá a volta em vez de parar na última ─────────────────────────
 *
 * A espera não tem duração conhecida. Parar na última deixaria a mesma frase
 * congelada pelo resto de um boot de trinta segundos — de volta à tela parada
 * que este desfile existe para não ser.
 *
 * ── Por que começa numa POSIÇÃO variável ─────────────────────────────────
 *
 * `inicio` é sorteado uma vez pela tela. Sem isso, quem abre o app dez vezes
 * por dia lê "Projeção do seu saldo" dez vezes e nunca chega na quarta frase
 * — porque a espera normal só dá tempo de uma. Começando em pontos
 * diferentes, as dez aparições mostram dez serviços.
 */
export const servicoDaVez = (passadas: number, inicio = 0): string =>
  SERVICOS[(inicio + passadas) % SERVICOS.length];
